import { AuthenticationServiceProvider } from '../authentication-service/authentication-service';
import { catchError, concatMap, map } from 'rxjs/operators';
import { ConfigServiceProvider } from '../config-service/config-service';
import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ENVIRONMENT } from '../../../../../environments/environment';

@Injectable()
export class AuthInterceptorProvider implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationServiceProvider, private configService: ConfigServiceProvider) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    if (this.isIdentityProviderRequest(request.url)) {
      return next.handle(request);
    }

    const openUrls = this.configService.getConfig('openUrls') as string[];
    if (openUrls.some((openUrl) => request.url.includes(openUrl))) {
      return next.handle(request);
    }

    return Observable.defer(() => this.authenticationService.getAccessToken()).pipe(
      map((token) => request.clone({ headers: request.headers.set('Authorization', `Bearer ${token}`) })),
      concatMap((authReq) => next.handle(authReq)),
      catchError((err, restart) => {
        if (err instanceof HttpErrorResponse && err.status === 401) {
          return Observable.concat(this.authenticationService.renewTokens(), restart);
        }
        throw err;
      }),
    );
  }

  private isIdentityProviderRequest(url: string): boolean {
    return url.startsWith(ENVIRONMENT.authServerBaseUrl);
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/services/auth-interceptor/auth-interceptor.ts